import { FONT_TYPE_SINGLE_LETTERS } from '../../constants/fontTypes';
import type { FontDataEntry } from './fontData';
import type { WehaGlobalSettings } from './types';

export type ConfiguratorState = {
  configurator?: {
    configuration?: {
      customdata?: {
        isOnDemandPrice?: boolean;
        wehaFontData?: FontDataEntry[];
      };
    };
  };
};

/** Font data from API; empty array when not yet loaded or when the request failed. */
export function selectWehaFontData(state: ConfiguratorState): FontDataEntry[] {
  return state.configurator?.configuration?.customdata?.wehaFontData ?? [];
}

export function isVerticalTextAvailable(gs: WehaGlobalSettings): boolean {
  return gs.fontType === FONT_TYPE_SINGLE_LETTERS;
}

export function isOnDemandPrice(state: ConfiguratorState): boolean {
  return Boolean(state.configurator?.configuration?.customdata?.isOnDemandPrice);
}